// extracted by mini-css-extract-plugin
module.exports = {"ConfirmConnection":"ConfirmConnection_ConfirmConnection__2zLtF","RemoteErrors":"ConfirmConnection_RemoteErrors__2EUi1","SwitchAccount":"ConfirmConnection_SwitchAccount__2imZp"};